import * as React from "react";
import Main from "./Components/Main";
import "url-search-params-polyfill";
import "promise-polyfill/src/polyfill";
import "react-app-polyfill/ie11";
import "babel-polyfill";
import "react-app-polyfill/stable";
import "./App.css";

class App extends React.Component {
  render() {
    return <Main />;
  }
}

export default App;
